import lazyLoad from 'app/shared-components/util/lazyLoad';
import authRoles from '../../auth/authRoles';

const PaymentSetupCompletePage = lazyLoad(() => import('./PaymentSetupCompletePage'));

const PaymentSetupCompleteConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'payment-setup-complete',
      element: <PaymentSetupCompletePage />,
    },
  ],
};

export default PaymentSetupCompleteConfig;
